// Content for "Why All Processes Without Bhakti Fail: The Hierarchy from Karma to Jñāna" topic

import type { TopicContent } from '../types';

const content: TopicContent = {
    primarySloka: {
        reference: 'Srimad Bhagavatam 1.5.12',
        sloka: `naiṣkarmyam apy acyuta-bhāva-varjitaṁ
na śobhate jñānam alaṁ nirañjanam |
kutaḥ punaḥ śaśvad abhadram īśvare
na cārpitaṁ karma yad apy akāraṇam ||`,
        translation:
            'Even the stage of jñāna without the bondage of karma (<strong>naiṣkarmyam api ... jñānam</strong>) is not glorious (<strong>na śobhate</strong>) if it is devoid of bhakti to the Supreme Lord (<strong>acyuta-bhāva-varjitaṁ</strong>). What is the use of having destroyed ignorance (<strong>alaṁ nirañjanam</strong>)? What then to speak of sakāma-karma which causes suffering, both during practice and at the stage perfection (<strong>kutaḥ punaḥ śaśvad abhadram</strong>), and niṣkāma-karma, when not offered to the Lord (<strong>īśvare na cārpitaṁ karma yad apy akāraṇam</strong>)?',
    },
    blocks: [
        {
            type: 'text',
            content:
                'Not only are the words important. <strong>If there is no bhakti, the work is useless</strong>.<br /><br />The realization coming from the words of the Vedas is useless without bhakti, what to speak of mere scriptural knowledge, and what to speak of niṣkāma-karma. And so much more, sakāma-karma is useless without bhakti.<br /><br /><strong>Even knowledge devoid of fruitive intentions does not appear wonderful without bhakti, in which one thinks of the Lord who has a form of knowledge and bliss <em>(acyuta-bhāva).</em></strong>',
        },
        {
            type: 'text',
            content:
                '<strong>Even if bhakti is present in jñāna and one thinks that the Lord and bhakti are mixed with māyā, then that does not produce liberation</strong>.<br /><br />Though devoid of ignorance (nirañjanam), though one has realized knowledge, what is the use of that knowledge (alam)? What then to speak of unrealized scriptural knowledge! One should not say that you can achieve liberation just by destroying ignorance.<br /><br /><strong>By the inconceivable energy of the Lord, the destroyed ignorance again arises.</strong> The Pariśiṣṭā-vacanam of the Vāsanā-bhāṣya says:',
        },
        {
            type: 'sloka',
            sloka: {
                reference: 'Pariśiṣṭā-vacanam of Vāsanā-bhāṣya',
                sloka: `jīvan-muktā api punar
bandhanaṁ yānti karmabhiḥ |
yady acintya-mahā-śaktau
bhagavaty aparādhinaḥ ||`,
                translation:
                    'Even the liberated persons again get bound by karma if they commit offense against the Lord, possessor of great, inconceivable powers.',
            },
        },
        {
            type: 'text',
            content: 'There it also says:',
        },
        {
            type: 'sloka',
            sloka: {
                reference: 'Pariśiṣṭā-vacanam of Vāsanā-bhāṣya',
                sloka: `jīvan-muktā prapadyante
kvacit saṁsāra-vāsanām |
yogino na vilipyante
karmabhir bhagavat-parāḥ ||`,
                translation:
                    'Liberated souls sometimes are subjected to birth and death, but the yogīs who surrender to the Lord are not touched by karma.',
            },
        },
        {
            type: 'text',
            content:
                "Thus the effect of jñāna is destruction of karma.<br /><br /><em>jñānāgniḥ sarva-karmāṇi bhasmasāt kurute 'rjuna</em>:<br /><br /><strong>O Arjuna, by the fire of knowledge all karmas are burned to ashes.</strong> (Bhagavad-Gītā 4.33)<br /><br />But that is not so wonderful because it is also said concerning rathayātrā in Viṣṇu-bhakti-candrodaya of another Purāṇa:",
        },
        {
            type: 'sloka',
            sloka: {
                reference: 'Viṣṇu-bhakti-candrodaya',
                sloka: `nānuvrajati yo mohād
vrajantaṁ jagad-īśvaram |
jñānāgni-dagdha-karmāpi
sa bhaved brahma-rākṣasaḥ ||`,
                translation:
                    'He who does not follow the Lord in his chariot when he moves becomes a brahma-rakṣasa even though he has destroyed all karmas with the fire of knowledge.',
            },
        },
        {
            type: 'text',
            content:
                "It will also be said later:<br /><br /><em>āruhya kṛcchreṇa paraṁ padaṁ tataḥ patanty adho 'nādṛta-yuṣmad-aṅghrayaḥ</em><br /><br /><strong>After reaching the height of liberation with great difficulty, again they fall down because they do not worship the lotus feet of the Lord.</strong> (Srimad Bhagavatam 10.2.32)",
        },
        {
            type: 'text',
            content:
                'Since jñāna is devoid of real bhakti to the Lord, <strong>the offense caused by thinking that the Lord is material is unavoidable.</strong><br /><br />If such jñāna devoid of bhakti is useless, <strong>what then to speak of karma which is filled with desires for enjoyment and which causes suffering (abhadram) at all times (śaśvat)</strong>--during practice and at the time of receiving the result.<br /><br />And even if the karma is without the goal of enjoyment (akāraṇam), <strong>because it is not offered to the Lord it is not successful.</strong>',
        },
    ],
};

export default content;
